import React from "react";

import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import LatestStories from "../../../components/Library/LatestStories";
import Privacy from "./Privacy";
import Terms from "./Terms";

const Legal = () => {
  return (
    <Layout>
      <Sidebar>
        <LatestStories/>
      </Sidebar>
      <Content>
        <Privacy />
        <Terms />
      </Content>
    </Layout>
  );
};

export default Legal;



// WEBPACK FOOTER //
// ./src/legal/components/Legal/Legal.js